import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, Download, Shield } from 'lucide-react';
export function SecondCTASection() {
  return <section className="py-12 md:py-20 bg-muted-lavender/10" data-id="element-188">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-190">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-deep-charcoal mb-4" data-id="element-191">
            No tienes que seguir adivinando qué comer ni cuándo entrenar.
          </h2>
          <p className="text-lg md:text-xl text-deep-charcoal/80" data-id="element-192">
            No tienes que seguir culpándote por algo que nunca fue tu culpa.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-3xl shadow-xl p-6 md:p-10 border-t-8 border-dusty-rose" data-id="element-193">
          <p className="text-lg font-bold text-deep-charcoal mb-6 text-center" data-id="element-194">
            Por $14.99 USD tienes acceso hoy mismo a:
          </p>

          <div className="space-y-4 mb-8" data-id="element-195">
            <div className="flex items-center gap-3 text-deep-charcoal" data-id="element-196">
              <div className="w-6 h-6 rounded-full bg-sage-green/20 flex items-center justify-center flex-shrink-0" data-id="element-197">
                <div className="w-2 h-2 rounded-full bg-sage-green" data-id="element-198"></div>
              </div>
              <span className="font-medium" data-id="element-199">
                Guía Maestra Código Hormonal 28D
              </span>
            </div>
            <div className="flex items-center gap-3 text-deep-charcoal" data-id="element-200">
              <div className="w-6 h-6 rounded-full bg-sage-green/20 flex items-center justify-center flex-shrink-0" data-id="element-201">
                <div className="w-2 h-2 rounded-full bg-sage-green" data-id="element-202"></div>
              </div>
              <span className="font-medium" data-id="element-203">
                Recetario Hormonal (30+ recetas)
              </span>
            </div>
            <div className="flex items-center gap-3 text-deep-charcoal" data-id="element-204">
              <div className="w-6 h-6 rounded-full bg-sage-green/20 flex items-center justify-center flex-shrink-0" data-id="element-205">
                <div className="w-2 h-2 rounded-full bg-sage-green" data-id="element-206"></div>
              </div>
              <span className="font-medium" data-id="element-207">Calendario Fitness Ciclo-Sync</span>
            </div>
            <div className="flex items-center gap-3 text-deep-charcoal" data-id="element-208">
              <div className="w-6 h-6 rounded-full bg-sage-green/20 flex items-center justify-center flex-shrink-0" data-id="element-209">
                <div className="w-2 h-2 rounded-full bg-sage-green" data-id="element-210"></div>
              </div>
              <span className="font-medium" data-id="element-211">
                Protocolo SOS Anti-Inflamación
              </span>
            </div>
          </div>

          <button onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="group relative w-full flex items-center justify-center px-8 py-5 text-lg md:text-xl font-bold text-white transition-all duration-300 bg-dusty-rose rounded-2xl hover:bg-dusty-rose/90 hover:shadow-xl hover:-translate-y-1 mb-4" data-id="element-212">
            SÍ, QUIERO MI PACK AHORA — $14.99 USD
            <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-213" />
          </button>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-sm text-deep-charcoal/60" data-id="element-214">
            <div className="flex items-center gap-2" data-id="element-215">
              <Lock className="w-4 h-4" data-id="element-216" />
              <span data-id="element-217">Pago seguro</span>
            </div>
            <span className="hidden md:inline" data-id="element-218">•</span>
            <div className="flex items-center gap-2" data-id="element-219">
              <Download className="w-4 h-4" data-id="element-220" />
              <span data-id="element-221">Descarga inmediata</span>
            </div>
            <span className="hidden md:inline" data-id="element-222">•</span>
            <div className="flex items-center gap-2" data-id="element-223">
              <Shield className="w-4 h-4" data-id="element-224" />
              <span data-id="element-225">Garantía 7 días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}